module.exports = __webpack_public_path__ + "static/img/home_spec_bg.ef71723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_spec_bg.jpg
// module id = B+kr
// module chunks = 0